<div class="software-override-modal">
  <div class="modal-header-row">
    <div>
      <h2>
        {{ 'software_override.modal.override_software' | translate }}
        @if (data.batch.name) {
          - {{ data.batch.name }}
        }
      </h2>
      <p>{{ 'software_override.license_batch.description' | translate }}</p>
    </div>
    <button
      class="modal-close-button"
      type="button"
      [attr.aria-label]="'license_manager.actions.close_aria' | translate"
      [matTooltip]="'license_manager.actions.close' | translate"
      [disabled]="saving"
      (click)="close()"
    >
      <span class="icon-close" aria-hidden="true"></span>
    </button>
  </div>

  <div class="modal-body">
    <app-device-software-override
      [linkedLicenseBatches]="[data.batch]"
      [licenseBatch]="data.batch"
      [initialArtifactOverrides]="
        data.batch.softwareVersionOverrides?.artifactOverrides ?? []
      "
      [initialBundleOverrides]="
        data.batch.softwareVersionOverrides?.bundleOverrides ?? []
      "
      [unresolvedOverrideIds]="
        data.batch.softwareVersionOverrides?.unresolvedOverrideIds ?? []
      "
      (overridesSaved)="close($event)"
    />
  </div>

  <footer class="modal-footer">
    <app-button
      class="cancel-button"
      [small]="true"
      [title]="'software_override.actions.cancel' | translate"
      [disabled]="saving"
      (click)="close()"
    ></app-button>
    <app-button
      [small]="true"
      [black]="true"
      [title]="
        (saving
          ? 'software_override.actions.saving'
          : 'software_override.actions.save'
        ) | translate
      "
      [disabled]="saveDisabled"
      (click)="save()"
    ></app-button>
  </footer>
</div>
